import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { FeedbackForm } from "@/components/landing/FeedbackForm";
import { Footer } from "@/components/landing/Footer";
import { Nav } from "@/components/landing/Nav";

export const Route = createFileRoute("/report-bug")({ component: ReportBugPage });

function ReportBugPage() {
  return (
    <div className="selection-lamp min-h-screen bg-paper text-ink">
      <Helmet>
        <title>Report a bug — Genie</title>
        <meta name="description" content="Send Genie beta feedback or report a bug." />
      </Helmet>
      <Nav />
      <main>
        <FeedbackForm />
      </main>
      <Footer />
    </div>
  );
}
